import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { getCurrentThemeId, isCssVariablesSupported } from 'owa-theme';
import * as React from 'react';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { themeSupportsDarkMode } from 'owa-theme';
import { TooltipHost } from 'office-ui-fabric-react/lib';
var styles = require('./Theme.scss');
var classNames = require('classnames/bind').bind(styles);
var spriteStyles = require('owa-sprite/dist/styles/theme_sprite.css');
var ThemeSwatch = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeSwatch, _super);
    function ThemeSwatch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (ev) {
            ev.stopPropagation();
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.themeId);
            }
        };
        return _this;
    }
    ThemeSwatch.prototype.render = function () {
        var themeId = this.props.themeId;
        var isChecked = themeId === getCurrentThemeId();
        var isDisabled = getIsDarkTheme() && isCssVariablesSupported() && !themeSupportsDarkMode(themeId);
        // TODO: Localize Tooltip
        return (React.createElement(TooltipHost, { content: isDisabled ? strings.theme_disabled_dark_mode_tooltip : '' },
            React.createElement("div", { className: classNames(styles.swatch, {
                    selected: isChecked,
                    disabled: isDisabled,
                }), onClick: this.onClick, "data-is-focusable": "true", role: "option", "aria-checked": isChecked, "aria-label": strings["themeDisplayName_" + themeId], title: strings["themeDisplayName_" + themeId] },
                React.createElement("i", { className: classNames(spriteStyles["theme-icon-" + themeId], styles.image) }))));
    };
    ThemeSwatch = tslib_1.__decorate([
        observer
    ], ThemeSwatch);
    return ThemeSwatch;
}(React.Component));
export default ThemeSwatch;
//# sourceMappingURL=ThemeSwatch.js.map